export default {
  A_STELLEN: "f950ee8c-3822-4654-a029-2388c7a00a42",
  A_PRUEFEN: "529ae4b8-cdc9-4148-8243-ff34ede602f8",
  A_ENTSCHEIDEN: "6132a117-748c-4f95-9c85-a4f248206ab4",
  A_BEWILLIGT: "b5973398-2c47-4e8e-9e18-4c5b9f58891f",
  A_ABGELEHNT: "8d90ec9d-1b2f-4552-b8e7-daea46457556"
};
